// eslint-disable-next-line import/no-extraneous-dependencies
import { type Context, createContext } from 'react';

import { type OverrideRegistry } from './types';

export const overrideContext: Context<OverrideRegistry> = createContext<OverrideRegistry>(
	new Map(),
);
